import React, { memo, useContext, useEffect, useRef, useState } from "react";
import { RestaurantContext } from "../../../../../../contexts/Restaurant";
import { SettingsContext } from "../../../../../../contexts/Settings";
import { FoodContext } from "../../../../../../contexts/Food";
import moment from "moment";
import { Flip, toast } from "react-toastify";
import LoyaltyImg from "../../../../public/loyalty.png";
import axios from "axios";
import { BASE_URL } from "../../../../../../BaseUrl";
import { useTranslation } from "react-i18next";
import { getDiscount, getTax, updateLoyaltyPoints, applyItemLoyaltyPoints } from "../helpers";
import {
  _t,
  getCookie,
  currencySymbolLeft,
  currencySymbolRight,
  formatPrice,
  getSystemSettings,
  getLoyaltyPoint,
  maxLoyaltyPoint,
  checkNetworkStatus,
  setApiTime,
  isTimeExpired,
  encryptAES128,
  getDisableLoyality,
  getLoyaltyItemsInfo,
  verifyAndFetchLoyalty,
  syncLoyaltyAndSendOTP,
  fetchVerifyOTP,
  getCustomerRegInfo,
  handleCardTransaction,
  processPaymentIntegrations
} from "../../../../../../functions/Functions";
import { useCustomHooks } from "../../../../../../functions/Hooks";
import { UserContext } from "../../../../../../contexts/User";
import SplitPayment from "../ItemModal/SplitPayment";
import { useHistory, useParams } from "react-router-dom";
import CardModal from "../../modal/CardModal";
import CustomSpinLoader from "../../../../../components/CustomSpinLoader";

const SettleOrder = ({
  managerId,
  showSettle,
  setSelectedKot,
  selectedDeptTag,
  cartTotal,
  cartSubTotal,
  selectedParty,
  selectedDeliveryType,
  newOrder,
  cartItems,
  setCartItems,
  buttonDisabled,
  setButtonDisabled,
  emptyCardOnChange,
  loyaltyPoint,
  setloyaltyPoint,
  tokenNumber,
  paymentTypeAvailable,
  returnMoneyUsd,
  setReturnMoneyUsd,
  serviceCharges,
  paidMoney,
  setPaidMoney,
  orderDetails,
  handleKotItems,
  totalsettle,
  setTotalSettle,
  theVat,
  theTax,
  setTheVatSettle,
  theVatSettle,
  showPriceOfEachOrderItem,
  setOrderDetails,
  setShowSettle,
  setNewSettings,
  deliveryCharges,
  newSettings,
  isSettle,
  fbrInvoiceNum,
  srbInvoiceNum,
  handleLocalPrint,
  handleReceiptPrint,
  token_No,
  setModal9Show,
}) => {
  const history = useHistory();
  const { order_id } = useParams();
  const { t } = useTranslation();
  const { roundFormatPrice, roundOffPrice, handleSubmitOffline, getOfflineApiUrl, syncLocalOrders, debouncedFetchResults, setCardItemInclusiveSettle, checkTaxType, getSubtotalInclusiveSettle, getBeforeTaxPricePayment } = useCustomHooks();
  const { workPeriodListForBranch, setWorkPeriodListForBranch } = useContext(RestaurantContext);
  const { propertyGroupById, getFoodGroupForPOS } = useContext(FoodContext);
  const {
    //common
    loading,
    setLoading,
    generalSettings,
    syncOrder,
    // showManageStock,
  } = useContext(SettingsContext);
  const { authUserInfo } = useContext(UserContext);

  const [activeItemInOrder, setActiveItemInOrder] = useState(null);

  //split payment
  const [payModal, setPayModal] = useState(false);
  const [payment, setPayment] = useState("");
  const [paySelected, setPaySelected] = useState(null);

  //vat
  const [theTaxSettle, setTheTaxSettle] = useState(0);
  const cardAdd = useRef();
  const [cardNumber, setCardNumber] = useState({
    first: "******",
    middle: "****",
    last: "",
    order_payment_bank: null,
  });
  const inputRefs = {
    first: useRef(),
    middle: useRef(),
    last: useRef(),
    paid: useRef(),
  };

  // check internet
  let networkStatus = true;

  // redeem point
  const handleRedeemPoint = (e, availablepoints = 0) => {
    const value = Number(e.target.value);
    const maxAllowed = Number(loyaltyPoint.maxRedeemPoints) > 0
      ? Math.min(loyaltyPoint.maxRedeemPoints, loyaltyPoint.availablePoints)
      : (Number(loyaltyPoint.availablePoints) || availablepoints);
    const isValid = value <= maxAllowed;

    if (isValid) {
      setloyaltyPoint((curr) => ({
        ...curr,
        redeemPoints: value
      }));
      let totalAfterLoyalty = Number(cartTotal) - Number(value);
      if (getSystemSettings(generalSettings, "user_wise_integration") == 1 ? authUserInfo.details.sbr_enabled === 1 : (orderDetails.branch.sbr_integration === 1 ||
        orderDetails.branch.fbr_integration === 1 || orderDetails.branch.kpra_integration === 1 ||
        orderDetails.branch.cbr_integration === 1 || orderDetails.branch?.pbr_integration === 1)) {
        totalAfterLoyalty += 1
      }
      setTotalSettle(totalAfterLoyalty);
    } else {
      if (getSystemSettings(generalSettings, "loyality_enable") === "techmixers") {
        const checkCanRedeem = JSON.parse(sessionStorage.getItem("techloyalty"));
        if (checkCanRedeem && Number(checkCanRedeem?.rdmptn_limit_prcnt)) {
          if (loyaltyPoint.maxRedeemPoints < loyaltyPoint.availablePoints) {
            toast.error(`You are allowed to redeem ${checkCanRedeem?.rdmptn_limit_prcnt}% (Rs.${getDiscount(cartTotal, checkCanRedeem?.rdmptn_limit_prcnt)}) of sale amount`, toastObj);
            return
          } else {
            toast.error(`You are allowed to redeem ${loyaltyPoint.availablePoints}.`, toastObj);
            return
          }
        }
      }
      toast.error("You can't redeem more than your max points", toastObj)
    }
  }

  //clear after settle 
  const handleClearSettle = () => {
    setCardNumber({
      first: "******",
      middle: "****",
      last: "",
      order_payment_bank: null,
    });
    setPayment("");
    setPaySelected(null);
    if (sessionStorage.getItem("techloyalty")) {
      sessionStorage.removeItem("techloyalty");
    }
  }

  const handleGoBack = () => {
    setShowSettle(false);
    setTotalSettle(0);
    setPaidMoney(0);
    setTheVatSettle(theVat);
    setReturnMoneyUsd(0);
    setPaySelected(null);
    setPayment("");
    setOrderDetails((curr) => ({
      ...curr,
      payment_type: null,
      order_tip: 0,
      card_number_settle: "",
    }));
    if (getSystemSettings(generalSettings, "tax_type") === "inclusive" && parseInt(getSystemSettings(generalSettings, "fixed_inclusive_tax")) === 1 &&
      orderDetails.payment_type && orderDetails.branch.branch_tax !== orderDetails.payment_type?.[0]?.tax_percent) {
      const { updatedCartItems, subtotal } = setCardItemInclusiveSettle(cartItems, orderDetails.payment_type?.[0]?.tax_percent || orderDetails.branch.branch_tax,
        orderDetails.branch.branch_tax, getSystemSettings(generalSettings, "loyality_enable") === "indoljItemWise");
      const getVat = roundOffPrice(getTax(orderDetails.branch.branch_tax, subtotal));
      getVat && setTheVatSettle(getVat);
      setCartItems(updatedCartItems);
    } else if (getSystemSettings(generalSettings, "loyality_enable") === "indoljItemWise") {
      const { items } = applyItemLoyaltyPoints(cartItems, getSystemSettings(generalSettings, "tax_type"), orderDetails.branch.branch_tax, "", true);
      setCartItems(items);
    }
    setCardNumber({
      first: "******",
      middle: "****",
      last: "",
      order_payment_bank: null,
    })

    setloyaltyPoint({
      qr_code: "",
      availablePoints: 0,
      earnedPoints: 0,
      redeemPoints: 0,
      phn_no: "",
      type: getSystemSettings(generalSettings, "loyality_enable") === "techmixers" ? "" : ("token"),
      maxRedeemPoints: "",
      customerName: "",
    })
  }

  const getCustomerInfo = async (value, isDirectHit = false) => {
    const params = {
      phn_no: value,
      branch: orderDetails.branch,
    }
    let res = "";
    if (isDirectHit) {
      res = await getCustomerRegInfo(params, setButtonDisabled)
    } else {
      res = await debouncedFetchResults(params, getCustomerRegInfo, setButtonDisabled);
    }

    if (res) {
      if (res?.returnvalue == 0 && res.success) {
        let availPoints = 0;
        const checkCond = (res.display_campaign_msg === "1" && Number(res.campaign_discount)) || (Number(res.redemp_req_amt) > 0);
        if (res.display_campaign_msg === "1" && Number(res.campaign_discount) > 0) {
          availPoints = roundOffPrice(totalsettle * res.campaign_discount);
        } else if (Number(res.redemp_req_amt) > 0) {
          availPoints = Number(res.redemp_req_amt) > Number(res.redeemable_amt) ? roundOffPrice(res.redeemable_amt) : roundOffPrice(res.redemp_req_amt);
        } else if (Number(res.rdmptn_limit_prcnt) > 0) {
          availPoints = roundOffPrice(getDiscount(totalsettle, res.rdmptn_limit_prcnt));
        } else if (Number(res.redeemable_amt) > 0) {
          availPoints = roundOffPrice(res.redeemable_amt);
        }
        if (availPoints && availPoints > cartTotal) {
          availPoints = cartTotal
        }
        setloyaltyPoint((curr) => ({
          ...curr,
          availablePoints: Number(res.redeemable_amt),
          earnedPoints: (res?.earned_points && Number(res.earned_points)) ?? 0,
          maxRedeemPoints: availPoints ? availPoints : Number(res.redeemable_amt),
          redeemPoints: checkCond ? availPoints : 0,
          verified: false,
          customerName: res?.cust_name || "",
        }))
        if (availPoints && checkCond) {
          let totalAfterLoyalty = Number(cartTotal) - Number(availPoints);
          if (getSystemSettings(generalSettings, "user_wise_integration") == 1 ? authUserInfo.details.sbr_enabled === 1 : (orderDetails.branch.sbr_integration === 1 ||
            orderDetails.branch.fbr_integration === 1 || orderDetails.branch.kpra_integration === 1 ||
            orderDetails.branch.cbr_integration === 1 || orderDetails.branch?.pbr_integration === 1)) {
            totalAfterLoyalty += 1
          }
          setTotalSettle(totalAfterLoyalty);
        }
        setOrderDetails((curr) => ({
          ...curr,
          newCustomerInfo: {
            ...curr.newCustomerInfo,
            name: res.cust_name,
            email: res.cust_email,
            phn_no: res.pos_cust_phone,
            gender: res.gender,
          },
        }))
      } else {
        setloyaltyPoint((curr) => ({
          ...curr,
          availablePoints: 0,
          earnedPoints: 0,
          maxRedeemPoints: 0,
          redeemPoints: 0,
          verified: false,
        }))
      }
    }
  }

  const handleToggle = async (option) => {
    if (getSystemSettings(generalSettings, "loyality_enable") === "techmixers") {
      setloyaltyPoint((curr) => ({
        ...curr,
        qr_code: curr.qr_code ?? "",
        type: option,
        redeemPoints: curr.qr_code ? curr.redeemPoints : 0,
      }));
      if (loyaltyPoint.phn_no?.length > 9 && option === "send-otp" && loyaltyPoint.type !== "send-otp") {
        const params = {
          phone: loyaltyPoint.phn_no,
          code: orderDetails.branch?.code,
        }
        let result = await syncLoyaltyAndSendOTP(params, setButtonDisabled);
      } else if (option === "get-info" && loyaltyPoint.type !== "get-info" && loyaltyPoint.phn_no?.length > 9) {
        getCustomerInfo(loyaltyPoint.phn_no, true);
      }
    } else {
      setloyaltyPoint((curr) => ({
        ...curr,
        qr_code: option === "phone" ? (orderDetails.newCustomerInfo?.phn_no || "") : "",
        type: option,
        availablePoints: 0,
        earnedPoints: 0,
        redeemPoints: 0,
        maxRedeemPoints: "",
        customerName: "",
      }));
    }
  };

  //clear paid and 
  const handleClearAmount = () => {
    setPaidMoney(0);
    setReturnMoneyUsd(0);
    setPayment("");
    setPaySelected(null);
  }

  //loyalty points calculation
  const handleCalLoyaltyPoints = (total, taxPercent = (orderDetails.branch?.branch_tax ?? 0), items = null) => {
    if (loyaltyPoint.redeemPoints && getSystemSettings(generalSettings, "loyality_enable") && getSystemSettings(generalSettings, "loyality_enable") !== "none") {
      if (getSystemSettings(generalSettings, "loyality_enable") === "techmixers") {
        if (sessionStorage.getItem("techloyalty") && (Math.min(loyaltyPoint.maxRedeemPoints, loyaltyPoint.availablePoints) === Number(loyaltyPoint.redeemPoints) ||
          Math.min(loyaltyPoint.maxRedeemPoints, loyaltyPoint?.points) === Number(loyaltyPoint.redeemPoints)) && Number(loyaltyPoint.redeemPoints)) {
          let availPoints = 0;
          const res = JSON.parse(sessionStorage.getItem("techloyalty"));
          if (res.display_campaign_msg === "1" && Number(res.campaign_discount) > 0) {
            availPoints = roundOffPrice(total * res.campaign_discount);
          } else if (Number(res.redemp_req_amt) > 0) {
            availPoints = Number(res.redemp_req_amt) > Number(res.redeemable_amt) ? roundOffPrice(res.redeemable_amt) : roundOffPrice(res.redemp_req_amt);
          } else if (Number(res.rdmptn_limit_prcnt) > 0) {
            availPoints = roundOffPrice(getDiscount(total, res.rdmptn_limit_prcnt));
          } else if (Number(res.redeemable_amt) > 0) {
            availPoints = roundOffPrice(res.redeemable_amt);
          }
          if (availPoints && availPoints > total) {
            availPoints = total
          }
          if (availPoints) {
            availPoints = Math.min(availPoints, loyaltyPoint.availablePoints)
          }
          setloyaltyPoint((curr) => ({
            ...curr,
            redeemPoints: availPoints,
            points: availPoints,
          }))
          return availPoints;
        } else if (Number(loyaltyPoint.redeemPoints) > total) {
          setloyaltyPoint((curr) => ({
            ...curr,
            redeemPoints: total,
            maxRedeemPoints: total,
          }))
          return total
        }
        return Number(loyaltyPoint.redeemPoints);
      } else if (getSystemSettings(generalSettings, "loyality_enable") === "indoljItemWise") {
        if (getSystemSettings(generalSettings, "tax_type") === "inclusive") {
          const point = roundOffPrice(updateLoyaltyPoints(items ?? newOrder, taxPercent));
          setloyaltyPoint((curr) => ({
            ...curr,
            redeemPoints: point,
            maxRedeemPoints: point,
          }))
          return point;
        }
        return Number(loyaltyPoint.redeemPoints);
      } else {
        const points = maxLoyaltyPoint(total);
        if ((points > 0 && points < loyaltyPoint.redeemPoints && loyaltyPoint.maxRedeemPoints === loyaltyPoint.redeemPoints && points > loyaltyPoint.maxRedeemPoints)) {
          setloyaltyPoint((curr) => ({
            ...curr,
            redeemPoints: points,
            maxRedeemPoints: points,
          }))
          return points;
        } else if (points > 0 && loyaltyPoint.availablePoints < points && loyaltyPoint.maxRedeemPoints === loyaltyPoint.redeemPoints) {
          setloyaltyPoint((curr) => ({
            ...curr,
            maxRedeemPoints: points,
            redeemPoints: loyaltyPoint.availablePoints,
          }))
          return Number(loyaltyPoint.availablePoints);
        } else {
          setloyaltyPoint((curr) => ({
            ...curr,
            maxRedeemPoints: points,
          }))
          return Number(loyaltyPoint.redeemPoints)
        }
      }
    }
    return 0
  }

  const handleClearAll = () => {
    handleClearAmount()
    let total = Number(cartTotal);
    if (getSystemSettings(generalSettings, "user_wise_integration") == 1 ? authUserInfo.details.sbr_enabled === 1 : (orderDetails.branch.sbr_integration === 1 ||
      orderDetails.branch.fbr_integration === 1 || orderDetails.branch.kpra_integration === 1 ||
      orderDetails.branch.cbr_integration === 1 || orderDetails.branch?.pbr_integration === 1)) {
      total += 1
    }
    let items = newOrder;
    if (getSystemSettings(generalSettings, "tax_type") === "inclusive" && parseInt(getSystemSettings(generalSettings, "fixed_inclusive_tax")) === 1 &&
      orderDetails.payment_type && orderDetails.branch.branch_tax !== orderDetails.payment_type?.[0]?.tax_percent) {
      const { updatedCartItems, subtotal } = setCardItemInclusiveSettle(cartItems, orderDetails.payment_type?.[0]?.tax_percent || orderDetails.branch.branch_tax, orderDetails.branch.branch_tax);
      items = Object.values(updatedCartItems);
      const getVat = roundOffPrice(getTax(orderDetails.branch.branch_tax, subtotal));
      getVat && setTheVatSettle(getVat);
      setCartItems(updatedCartItems);
    }
    const calLoyaltyPoint = handleCalLoyaltyPoints(total, orderDetails.branch.branch_tax, items);
    if (calLoyaltyPoint > 0) {
      total -= calLoyaltyPoint
    }
    setTheVatSettle(theVat)
    setTotalSettle(total);
    setOrderDetails((curr) => ({
      ...curr,
      payment_type: null,
      card_number_settle: "",
    }));
    setCardNumber({
      first: "******",
      middle: "****",
      last: "",
      order_payment_bank: null,
    });
  }
  // split pay on click
  const handleClick = () => {
    setPaidMoney(0);
    setReturnMoneyUsd(0);
    setPayment("");
    setTheVatSettle(theVat);
    setPaySelected(null);
    setOrderDetails({
      ...orderDetails,
      payment_type: null,
    });
    setPayModal(false)
  }

  //payment type select
  const handleSetPayment = (pay) => {
    setCardNumber({
      first: "******",
      middle: "****",
      last: "",
      order_payment_bank: null,
    });
    if (pay?.view_card === 1 || Number(pay?.bank_required) === 1) {
      cardAdd.current.classList += " showing";
      inputRefs.last.current.focus();
    }
    setPaySelected(pay)
  }

  //debounce
  const handleAutoSplitPayment = (value) => {
    let totalAmount = Number(cartTotal);
    if (getSystemSettings(generalSettings, "user_wise_integration") == 1 ? authUserInfo.details.sbr_enabled === 1 : (orderDetails.branch.sbr_integration === 1 ||
      orderDetails.branch.fbr_integration === 1 || orderDetails.branch.kpra_integration === 1 ||
      orderDetails.branch.cbr_integration === 1 || orderDetails.branch?.pbr_integration === 1)) {
      totalAmount += 1
    }
    let remainingAmount = totalAmount - parseFloat(value);
    if (loyaltyPoint.redeemPoints) {
      remainingAmount -= Number(loyaltyPoint.redeemPoints);
    }
    if (remainingAmount > 0) {
      setPayment((prevPayment) => ({ ...prevPayment, select_split: roundOffPrice(remainingAmount) }));
    } else {
      setPayment((curr) => {
        const newData = {
          ...curr
        }
        newData["select_split"] && delete newData["select_split"]
        return newData
      });
    }
  }

  //get tech made loyalty points
  const handleGetLoyaltyChange = async (e) => {
    const { name, value } = e?.target;
    setloyaltyPoint((curr) => ({
      ...curr,
      [name]: value,
    }))
    if (getSystemSettings(generalSettings, "loyality_enable") === "techmixers") {
      if (loyaltyPoint.type !== "code" && loyaltyPoint.type !== "send-otp" && loyaltyPoint.type !== "get-info") {
        toast.error("Please select otp/info or code.", toastObj);
        return
      }
      if (loyaltyPoint.type === "get-info" && value?.length > 9) {
        getCustomerInfo(value);
      } else if (loyaltyPoint.type === "code") {
        if (loyaltyPoint.phn_no?.length > 9 && e.target.name === "qr_code" && value?.length > 3) {
          const params = {
            phone: loyaltyPoint.phn_no,
            code: orderDetails.branch?.code,
            otp_code: value,
          }
          let result = await debouncedFetchResults(params, fetchVerifyOTP, setButtonDisabled);
          if (result && result.success && result.returnvalue == 0) {
            setloyaltyPoint((curr) => ({
              ...curr,
              verified: true,
            }))
          }
        }
      }
      // else if(loyaltyPoint.type === "send-otp"){
      //   if(value?.length > 9 && e.target.name === "phn_no"){
      //     const params = {
      //       phone: value,
      //       code: orderDetails.branch?.code,
      //     }
      //     let result = await debouncedFetchResults(params, syncLoyaltyAndSendOTP, setButtonDisabled);
      //   }
      // }
    }
  }

  // handle get loyalty indolj input change
  const handleGetIndoljChange = async (e) => {
    const value = e.target.value;
    setloyaltyPoint((curr) => ({
      ...curr,
      qr_code: value,
    }))
    if (value && (loyaltyPoint.type === "phone" ? (value?.length > 9) : (value?.length > 4))) {
      const params = {
        phone: value,
        code: loyaltyPoint.type,
      }
      if (getSystemSettings(generalSettings, "loyality_enable") === "indoljItemWise") {
        const newParams = {
          ...params,
          directSettle: true,
          items: newOrder
        }
        let result = await debouncedFetchResults(newParams, getLoyaltyItemsInfo, setButtonDisabled);
        if (result) {
          const { items, points } = applyItemLoyaltyPoints(cartItems, getSystemSettings(generalSettings, "tax_type"), orderDetails.branch.branch_tax, result, true);
          const roundedPoints = roundOffPrice(points);
          setCartItems(items);
          setloyaltyPoint((curr) => ({
            ...curr,
            maxRedeemPoints: roundedPoints,
            customerName: result.data?.client_info?.client_name || "",
            verified: false,
          }));
          if (!orderDetails.newCustomerInfo?.phn_no) {
            setOrderDetails((curr) => ({
              ...curr,
              newCustomerInfo: {
                ...curr.newCustomerInfo,
                name: result.data?.client_info?.client_name || orderDetails.newCustomerInfo?.name,
                phn_no: result.data?.client_info?.client_phone_number || orderDetails.newCustomerInfo?.phn_no
              }
            }));
          }
          handleRedeemPoint({ target: { name: "redeemPoints", value: roundedPoints } }, roundedPoints);
        } else {
          setloyaltyPoint((curr) => ({
            ...curr,
            maxRedeemPoints: 0,
            customerName: "",
          }));
          handleRedeemPoint({ target: { name: "redeemPoints", value: 0 } }, 0);
        }
      } else {
        let result = await debouncedFetchResults(params, verifyAndFetchLoyalty, setButtonDisabled);
        if (loyaltyPoint.type !== "phone" && !localStorage.getItem("loyalty")) {
          await getLoyaltyPoint();
        }
        if (result?.points >= 0) {
          setloyaltyPoint((curr) => ({
            ...curr,
            availablePoints: result.points,
            maxRedeemPoints: maxLoyaltyPoint(totalsettle),
            customerName: result?.customerName || "",
            verified: true,
          }))
        }
      }
      setButtonDisabled(false)
    }
  };

  //split payment on chnage
  const handleSplitPayment = (e) => {
    e.preventDefault();
    const { id, value } = e.target;
    if (payment && (value == 0 || value === "")) {
      setPayment((curr) => {
        const newData = {
          ...curr
        }
        newData[id] && delete newData[id];
        if (!isNaN(Number(id))) {
          newData["select_split"] && delete newData["select_split"]
        }
        return newData
      });

    } else {
      setPayment((prevPayment) => ({ ...prevPayment, [id]: value }));
      if (!isNaN(Number(id))) {
        handleAutoSplitPayment(value);
      }
    }
  };

  //split payment submit
  const handleSetpaymentTypeMuliple = (e) => {
    e.preventDefault();
    if (payment) {
      if (!paySelected) {
        toast.error(
          "Please select the payment type to split payment", toastObj
        );
        return false;
      }
      let total = 0;

      const paymentMethod = payment && Object?.keys(payment).map((id) => {
        const amount = parseFloat(payment[id]);
        const type = isNaN(Number(id)) ? paySelected : paymentTypeAvailable.find(payType => payType.id === Number(id));
        const taxAmount = (getBeforeTaxPricePayment(amount, orderDetails.branch.branch_tax));
        total += amount;
        return {
          ...type,
          tax_percent: orderDetails.branch.branch_tax,
          tax_amount: roundOffPrice(taxAmount),
          bill_amount: amount
        };
      });
      let localCurrency = JSON.parse(localStorage.getItem("currency"));
      let theUsdPaid = total / localCurrency.rate;
      let totalAmount = parseFloat(cartTotal);
      if (getSystemSettings(generalSettings, "user_wise_integration") == 1 ? authUserInfo.details.sbr_enabled === 1 : (orderDetails.branch.sbr_integration === 1 ||
        orderDetails.branch.fbr_integration === 1 || orderDetails.branch.kpra_integration === 1 ||
        orderDetails.branch.cbr_integration === 1 || orderDetails.branch?.pbr_integration === 1)) {
        totalAmount += 1
      }
      if (loyaltyPoint.redeemPoints) {
        totalAmount -= Number(loyaltyPoint.redeemPoints)
      }
      if (roundOffPrice(theUsdPaid) > roundOffPrice(totalAmount)) {
        setPayModal(true)
        setPaidMoney(0);
        setTheVatSettle(theVat);
        setReturnMoneyUsd(0);
        setTotalSettle(parseFloat(roundOffPrice(totalAmount)));
        toast.error(
          "Please enter paid amount exact equal to the total bill amount",
          toastObj
        );
        return false
      }

      if (roundOffPrice(theUsdPaid) < roundOffPrice(totalAmount)) {
        setPayModal(true)
        setReturnMoneyUsd(0);
        setPaidMoney(0);
        setTheVatSettle(theVat);
        setTotalSettle(parseFloat(roundOffPrice(totalAmount)));
        toast.error(
          "Please enter paid amount atleast equal to the total bill amount",
          toastObj
        );
      } else {
        setTheTaxSettle(orderDetails.branch.branch_tax);
        setTheVatSettle(theVat);
        setTotalSettle(parseFloat(roundOffPrice(totalAmount)));
        setPaidMoney(parseFloat(roundOffPrice(total)));
        setPayModal(false)
        setOrderDetails((curr) => ({
          ...curr,
          payment_type: paymentMethod,
        }));
        let theReturnMoney = theUsdPaid - parseFloat(totalAmount);
        setReturnMoneyUsd(roundOffPrice(theReturnMoney));
      }

    } else {
      toast.error(
        "Please select the payment type to split payment",
        toastObj
      );
    }

  };

  const handleCardSubmit = (e) => {
    e.preventDefault();

    // if(cardNumber.first?.length < 6){
    //  toast.error("Please enter valid card number");
    //  return false
    // }else 
    if (cardNumber.last?.length < (orderDetails.payment_type?.[0]?.digit_required || 6)) {
      toast.error("Please enter valid card number");
      return false
    }

    const currentPaymentType = paySelected || orderDetails.payment_type?.[0];
    if (Number(currentPaymentType?.bank_required) === 1 && !cardNumber.order_payment_bank) {
      toast.error(`${_t(t("Please select a bank"))}`);
      return false;
    }

    const cardNumberFinal = cardNumber.first + cardNumber.middle + cardNumber.last;
    setOrderDetails({
      ...orderDetails,
      card_number_settle: cardNumberFinal,
      order_payment_bank: cardNumber.order_payment_bank,
    })

    cardAdd.current.classList.remove("showing");
  }

  const handleCardChange = (part, value) => {
    setCardNumber((prev) => ({
      ...prev,
      [part]: value,
    }));
  };

  useEffect(() => {
    if (showSettle) {
      inputRefs.paid && inputRefs.paid.current.focus();
    }
  }, [showSettle])

  // LOCAL FUNCTIONS
  function bracketReplace(id) {
    let property_group_id = id.replace(/[\[\]']+/g, "");
    return property_group_id;
  }

  const toastObj = {
    position: "bottom-center",
    autoClose: 7000,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    className: "text-center toast-notification",
  };

  //payment type pos 2
  const handleSetpaymentTypeSingle = (payment_type) => {
    let b_tax = orderDetails.branch?.payment_tax[payment_type.name];
    if (payment_type?.view_card === 1 || Number(payment_type?.bank_required) === 1) {
      cardAdd.current.classList += " showing";
      inputRefs.last.current.focus();
    }
    setCardNumber({
      first: "******",
      middle: "****",
      last: "",
      order_payment_bank: null,
    });
    setPaySelected(null);
    setPayment("");

    let inclusive_vat = 0;
    let previous_amount = 0;
    let new_amount = 0;
    let totalSettle2 = parseFloat(cartTotal);
    if (getSystemSettings(generalSettings, "user_wise_integration") == 1 ? authUserInfo.details.sbr_enabled === 1 : (orderDetails.branch.sbr_integration === 1 ||
      orderDetails.branch.fbr_integration === 1 || orderDetails.branch.kpra_integration === 1 ||
      orderDetails.branch.cbr_integration === 1 || orderDetails.branch?.pbr_integration === 1)) {
      totalSettle2 += 1
    }
    let localCurrency = JSON.parse(localStorage.getItem("currency"));
    if (getSystemSettings(generalSettings, "tax_type") === "inclusive" && parseInt(getSystemSettings(generalSettings, "fixed_inclusive_tax")) === 1) {
      let items = newOrder;
      if (b_tax > 0 && b_tax !== orderDetails.branch.branch_tax) {
        setTheTaxSettle(b_tax);
        const { updatedCartItems, subtotal } = setCardItemInclusiveSettle(cartItems, orderDetails.payment_type?.[0]?.tax_percent || orderDetails.branch.branch_tax, b_tax);
        inclusive_vat = roundOffPrice(getTax(b_tax, subtotal))
        inclusive_vat && setTheVatSettle(inclusive_vat);
        setCartItems(updatedCartItems);
      } else {
        setTheTaxSettle(orderDetails.branch.branch_tax);
        const { updatedCartItems, subtotal } = setCardItemInclusiveSettle(cartItems, orderDetails.payment_type?.[0]?.tax_percent || orderDetails.branch.branch_tax, orderDetails.branch.branch_tax);
        items = Object.values(updatedCartItems);
        inclusive_vat = roundOffPrice(getTax(orderDetails.branch.branch_tax, subtotal));
        inclusive_vat && setTheVatSettle(inclusive_vat);
        setCartItems(updatedCartItems);
      }
      const calLoyaltyPoint = handleCalLoyaltyPoints(totalSettle2, orderDetails.branch.branch_tax, items);
      if (calLoyaltyPoint > 0) {
        totalSettle2 -= calLoyaltyPoint
      }
      setTotalSettle(parseFloat(roundOffPrice(totalSettle2)));
      setPaidMoney(parseFloat(roundOffPrice(totalSettle2)));
    } else {
      if (b_tax && b_tax >= 0) {
        setTheTaxSettle(b_tax);
        let vatCalculate = checkTaxType(cartSubTotal, orderDetails.scheme.discount_amount);
        inclusive_vat = vatCalculate * (parseFloat(b_tax) / 100);
        previous_amount = parseFloat(cartTotal) - parseFloat(theVat);
        new_amount = previous_amount + inclusive_vat;

        if (getSystemSettings(generalSettings, "user_wise_integration") == 1 ? authUserInfo.details.sbr_enabled === 1 : (orderDetails.branch.sbr_integration === 1 ||
          orderDetails.branch.fbr_integration === 1 || orderDetails.branch.kpra_integration === 1 ||
          orderDetails.branch.cbr_integration === 1 || orderDetails.branch?.pbr_integration === 1)) {
          new_amount += 1
        }

        const calLoyaltyPoint = handleCalLoyaltyPoints(new_amount, b_tax)
        if (calLoyaltyPoint > 0) {
          new_amount -= calLoyaltyPoint
        }
        totalSettle2 = new_amount;
        setTheVatSettle(parseFloat(roundOffPrice(inclusive_vat)));
        setTotalSettle(parseFloat(roundOffPrice(new_amount)));
        setPaidMoney(parseFloat(roundOffPrice(new_amount)));

      } else {
        setTheTaxSettle(orderDetails.branch.branch_tax);
        const theUsdPaid = (new_amount ? new_amount : paidMoney) / localCurrency?.rate;
        const calLoyaltyPoint = handleCalLoyaltyPoints(totalSettle2);
        if (calLoyaltyPoint > 0) {
          totalSettle2 -= calLoyaltyPoint
        }
        if (roundOffPrice(theUsdPaid) < roundOffPrice(totalSettle2)) {
          setReturnMoneyUsd(0);
          toast.error("Please enter paid amount atleast equal to the total bill amount", toastObj);
        }
        setTheVatSettle(theVat);
        setTotalSettle(parseFloat(roundOffPrice(totalSettle2)));
      }
    }

    let theUsdPaid = (new_amount ? new_amount : paidMoney) / localCurrency?.rate;
    const tax_percent = b_tax > 0 ? b_tax : orderDetails.branch.branch_tax;
    const tax_amount = inclusive_vat > 0 ? inclusive_vat : theVat;

    setOrderDetails((curr) => ({
      ...curr,
      payment_type: [{ ...payment_type, bill_amount: parseFloat(roundOffPrice(totalSettle2)), tax_percent, tax_amount }],
      card_number_settle: "",
    }));
    let theReturnMoney = roundOffPrice(theUsdPaid) - roundOffPrice(totalSettle2);
    setReturnMoneyUsd(roundOffPrice(theReturnMoney));
  };

  // Validate & settle the current POS order
  const handleSettleOrder = async (e) => {
    e.preventDefault();

    const paymentTypes = orderDetails?.payment_type;

    // Card number required when payment type has view_card enabled
    const requiresCard = paymentTypes?.[0]?.view_card === 1;
    const cardMissing =
      orderDetails.card_number_settle === null ||
      orderDetails.card_number_settle === "";
    if (requiresCard && cardMissing) {
      toast.error(`${_t(t("Please Enter Card Number"))}`, toastObj);
      cardAdd.current.classList += " showing";
      return false;
    }

    const requiresBank = Number(paymentTypes?.[0]?.bank_required) === 1;
    if (requiresBank && !cardNumber?.order_payment_bank) {
      toast.error(`${_t(t("Please select a bank"))}`, toastObj);
      cardAdd.current.classList += " showing";
      return false;
    }

    // Single payment: bill amount must equal total settle (auto-correct if mismatched)
    if (
      paymentTypes?.length === 1 &&
      paymentTypes[0]?.bill_amount !== totalsettle
    ) {
      toast.error(`${_t(t("Bill amount not match to total"))}`, toastObj);
      setOrderDetails((curr) => ({
        ...curr,
        payment_type: [
          { ...curr.payment_type[0], bill_amount: totalsettle },
        ],
      }));
      return false;
    }

    // Token must be selected / generated
    if (!orderDetails.token?.id || typeof orderDetails.token !== "object") {
      tokenNumber();
      return false;
    }

    // Foodpanda: enforce ref no length when required
    if (
      selectedParty?.name.match(/food(.*)panda/i) &&
      parseInt(selectedParty.show_ref_no) === 1 &&
      orderDetails.newCustomerInfo.refNo?.length < selectedParty.ref_min &&
      !order_id
    ) {
      toast.error(
        `${_t(t(`Please enter ref no between ${selectedParty.ref_min}-${selectedParty.ref_max} digits`))}`,
        toastObj
      );
      return false;
    }

    // Order must have items
    if (!(newOrder && newOrder.length > 0)) {
      toast.error("Please add items in order list", toastObj);
      return false;
    }

    if (isNaN(totalsettle)) {
      toast.error(`${_t(t("Total amount can't be NaN"))}`, toastObj);
      return false;
    }

    // Paid amount must cover total bill
    if (paidMoney < totalsettle) {
      toast.error(
        "Please enter paid amount atleast equal to the total bill amount",
        toastObj
      );
      return false;
    }

    // Payment method required
    if (orderDetails.payment_type === null) {
      toast.error("Please Select The Payment Type", toastObj);
      return false;
    }

    // Customer info required when any selected payment has customer_mandatory
    const requiresCustomer = (Array.isArray(paymentTypes) ? paymentTypes : []).some(
      (pay) => Number(pay?.customer_mandatory) === 1
    );
    const customerInfo = orderDetails?.newCustomerInfo || {};
    const hasCustomerInfo = Boolean(
      (customerInfo?.name && String(customerInfo.name).trim()) ||
        (customerInfo?.phn_no && String(customerInfo.phn_no).trim())
    );
    if (requiresCustomer && !hasCustomerInfo) {
      toast.error(`${_t(t("Please add customer information"))}`, toastObj);
      if (typeof setModal9Show === "function") {
        setModal9Show(true);
      }
      return false;
    }

    setNewSettings({
      ...newSettings,
      vat: theTax > 0 ? theTax : orderDetails.branch.branch_tax,
    });
    setButtonDisabled(true);
    setReturnMoneyUsd(roundOffPrice(paidMoney - totalsettle));
    axiosRequestForSettle();
  };

  const createSettleOrder = (url, formData) => {
    const offlineUrl = getOfflineApiUrl("/settings/new-order");

    axios
      .post(url, formData, {
        headers: { Authorization: `Bearer ${getCookie()}` },
        timeout: 60000,
      })
      .then(async (res) => {
        if (res.data === "exists") {
          toast.error(`${_t(t("Order already settle, You have click settle button again & again"))}`, toastObj);
          setSelectedKot({});
          history.push('/dashboard/pos');
          setSelectedKot({});
          setButtonDisabled(false);
          setLoading(false);
          return false
        }
        handleCreateSettleOrder(res);
        if (parseInt(authUserInfo.details?.offline_enable) === 1) {
          formData.offline_status = 1;
          handleSubmitOffline(formData, offlineUrl);
        }
      })
      .catch(async (error) => {

        if (parseInt(getSystemSettings(generalSettings, "fgs_enable")) === 1 && error.response?.data?.message !== "") {
          toast.error(<span style={{ whiteSpace: "pre-line" }}>{error.response.data.message}</span>, toastObj);
          setSelectedKot({});
          setButtonDisabled(false);
          setLoading(false);
          return false
        }
        if (!networkStatus && parseInt(authUserInfo.details?.offline_enable) === 1) {
          formData.offline_status = 0;
          const offlineData = await handleSubmitOffline(formData, offlineUrl);
          if (offlineData) {
            let newRes = {};
            let workperiod = [];
            workperiod.push(workPeriodListForBranch);
            newRes.data = workperiod;
            handleCreateSettleOrder(newRes);
          } else {
            setButtonDisabled(false);
          }
          setLoading(false);

        } else {

          setSelectedKot({});
          let data = [];
          data.push(workPeriodListForBranch);
          //set work period
          let theWorkPeriod = null;
          if (
            orderDetails.branch !== undefined && orderDetails.branch !== null &&
            authUserInfo.details.user_type !== "staff" && authUserInfo.details.user_type !== "manager"
          ) {
            theWorkPeriod = data[0] &&
              data[0].find((tempWorkPeriod) => {
                return (
                  (orderDetails.branch.id === parseInt(tempWorkPeriod.branch_id)) && tempWorkPeriod.ended_at === null
                );
              });
          } else {
            theWorkPeriod = data && data[0][0];
          }
          setTimeout(() => {
            setNewSettings({
              ...newSettings,
              vat: orderDetails.branch.branch_tax,
              workPeriod:
                theWorkPeriod !== undefined ? theWorkPeriod : null,
            });
          }, 500);
          setLoading(false);
          setButtonDisabled(false);
          if (error.response?.data?.status === 0) {
            toast.error(`${_t(t(error.response.data?.message))}`, toastObj);
          } else if (error.response?.data?.status === 2) {
            toast.error(`${_t(t(error.response.data?.message))}`, toastObj);
            emptyCardOnChange(selectedDeliveryType, selectedParty);
          } else if (networkStatus) {
            toast.error(`${_t(t("Please contact support"))}`, toastObj);
          } else {
            toast.error(`${_t(t("Please check your internet connection"))}`, toastObj);
          }
        }
      });
  };

  //axios request for settlement
  const axiosRequestForSettle = async () => {
    let api = order_id ? "/settings/settle-submitted-order" : "/settings/settle-order";
    let url = BASE_URL + api;
    let localCurrency = JSON.parse(localStorage.getItem("currency"));
    networkStatus = await checkNetworkStatus();
    let partyFinal = {
      partyId: selectedParty && selectedParty.id,
      partyName: selectedParty && selectedParty.name,
      partyPercent: selectedParty && selectedParty.receivable_amount,
      partyRefNo: selectedParty && selectedParty.show_ref_no,
      associate_with_payment_type: selectedParty && selectedParty.associate_with_payment_type
    }

    let orderTypeFinal = {
      orderTypeId: selectedDeliveryType && selectedDeliveryType.id,
      orderTypeName: selectedDeliveryType && selectedDeliveryType.name,
    }

    if (
      (!orderTypeFinal && !orderTypeFinal?.orderTypeId) ||
      (!partyFinal && !partyFinal?.partyId)
    ) {
      let error = "";
      if (
        (!selectedParty || !selectedParty?.id) ||
        (!partyFinal && !partyFinal.partyId)
      )
        error = "party";
      if (
        (!selectedDeliveryType || !selectedDeliveryType?.id) ||
        (!orderTypeFinal && !orderTypeFinal?.orderTypeId)
      )
        error = "delivery type";
      if (error) {
        toast.error(`Please select ${error} first.`);
        return false
      }
    }

    let paymentResponse = await processPaymentIntegrations(
      orderDetails.branch?.payment_integration,
      orderDetails.payment_type,
      orderDetails.token?.id,
      orderDetails.unique_token,
      orderDetails.branch
    );

    let paymentType = (orderDetails.payment_type || [])

    if (paymentResponse) {
      const integrationRes = paymentResponse?.response || paymentResponse;
      if ((integrationRes?.response !== "APPROVED") || integrationRes?.error) {
        setButtonDisabled(false);
        return false;
      }
      paymentType = paymentType.map((item) => {
        if (
          parseInt(item?.id) === parseInt(integrationRes.payment_type_id)
        ) {
          return {
            ...item,
            payment_integration: integrationRes?.success ? integrationRes.data : integrationRes.error,
          };
        }
        return item;
      });
    }


    let formData = {
      type: "settle",
      branch: orderDetails.branch,
      manager_id: managerId ? managerId : null,
      card_number: orderDetails.card_number,
      payment_card_number: orderDetails.card_number_settle,
      order_payment_bank: cardNumber.order_payment_bank?.id ?? null,
      order_tip: orderDetails.order_tip,
      loyalty_type: loyaltyPoint.type,
      loyalty_qr_code: loyaltyPoint.qr_code,
      redeem_points: loyaltyPoint.redeemPoints,
      loyalty_phn_no: loyaltyPoint.phn_no,
      available_points: loyaltyPoint.availablePoints,
      table: orderDetails.table,
      table_id: orderDetails.table_id,
      table_name: orderDetails.table_name,
      dept_tag_id: selectedDeptTag?.id,
      dept_tag_name: selectedDeptTag?.name,
      waiter_id: orderDetails.waiter ? orderDetails.waiter.id : "",
      waiter_name: orderDetails.waiter ? orderDetails.waiter.name : "",
      dept_tag: selectedDeptTag,
      waiter: orderDetails.waiter,
      payment_type: paymentType,
      payment_amount: orderDetails.payment_amount,
      customerInfo: orderDetails.newCustomerInfo,
      note_to_rider: orderDetails.note_to_rider,
      token: orderDetails.token,
      unique_token: orderDetails.unique_token,
      total_guest: orderDetails.total_guest,
      orderItems: newOrder,
      serviceCharge: deliveryCharges,
      scheme: orderDetails.scheme,
      order_id: null,
      discount: orderDetails.discount,
      orderTypeDetails: orderTypeFinal?.orderTypeId ? orderTypeFinal : orderDetails.orderTypeDetails,
      partyDetails: partyFinal?.partyId ? partyFinal : orderDetails.partyDetails,
      service_amount: serviceCharges,
      subTotal: getSubtotalInclusiveSettle(newOrder, cartSubTotal, orderDetails.payment_type?.length === 1),
      totalPayable: totalsettle,
      paidMoney: paidMoney,
      theVat: theVatSettle > 0 ? theVatSettle : theVat,
      tax_percent: theTaxSettle > 0 ? theTaxSettle : theTax,
      dept_commission: selectedDeptTag?.commission || 0,
      localCurrency: localCurrency,
      workPeriod: newSettings.workPeriod,
      payment_integration: paymentResponse?.response 
        ? (paymentResponse.response?.success ? paymentResponse.response.data : paymentResponse.response.error)
        : (paymentResponse ? (paymentResponse?.success ? paymentResponse.data : paymentResponse.error) : ""),
    };

    handleKotItems();

    setLoading(true);
    createSettleOrder(url, formData)

  };

  // save to local if offline
  const handleCreateSettleOrder = async (res, local = false) => {
    if (res.data !== "ended") {
      if (res.data !== "paymentIssue") {
        if (networkStatus && parseInt(authUserInfo.details?.offline_enable) === 1 && !syncOrder) {
          syncLocalOrders();
        }
        isSettle.current = 1;
        fbrInvoiceNum.current = res.data[2];
        srbInvoiceNum.current = {
          number: res.data[3],
          url: res.data[res.data.length - 2]
        };
        if (isTimeExpired("apiTime")) {
          getFoodGroupForPOS();
          setApiTime("apiTime");
        }
        //getFoodGroup();
        if (local == false) {
          let formatTime = moment(res.data[5]).format('DD-MMM-YYYY hh:mm A');
          const orderId = res.data[7];
          let hashId = "";
          if (parseInt(getSystemSettings(generalSettings, "is_feedback")) === 1) {
            hashId = await encryptAES128(orderId);
          }
          token_No.current = parseInt(getSystemSettings(generalSettings, "order_no")) === 1 ? { id: res.data[4] ? res.data[4] : orderDetails.token?.id, time: formatTime, order_id: orderId, hash_id: hashId } : { id: res.data[1] ? res.data[1] : orderDetails.token?.id, time: formatTime, order_id: orderId, hash_id: hashId };
          setOrderDetails({
            ...orderDetails,
            token: {
              ...orderDetails.token,
              id: res.data[1] ? res.data[1] : orderDetails.token?.id,
              order_id: orderId,
              hash_id: hashId
            },
            order_No: res.data[4] ? res.data[4] : orderDetails.token?.id,
          })
        }
        //setCustomerForSearch(res.data[0][1]);
        // setWorkPeriodList(res.data[0][0]);
        setWorkPeriodListForBranch(res.data[0]);

        //set work period
        let theWorkPeriod = null;
        if (
          orderDetails.branch !== undefined &&
          orderDetails.branch !== null &&
          authUserInfo.details.user_type !== "staff" && authUserInfo.details.user_type !== "manager"
        ) {
          theWorkPeriod =
            res.data[0] &&
            res.data[0].find((tempWorkPeriod) => {
              return (
                orderDetails.branch.id ===
                parseInt(tempWorkPeriod.branch_id) && tempWorkPeriod.ended_at === null
              );
            });
        } else {
          theWorkPeriod = res.data[0][0];
        }

        //set work period here
        setNewSettings({
          ...newSettings,
          vat:
            theTax > 0 ? theTax : orderDetails.branch.branch_tax,
          workPeriod:
            theWorkPeriod !== undefined ? theWorkPeriod : null,
        });

        setloyaltyPoint((curr) => ({
          ...curr,
          earnedPoints: Number(res.data[res.data.length - 1]?.rwrds_earned ?? 0),
        }));

        const directPrint = parseInt(orderDetails.branch?.direct_ip_print) || parseInt(getSystemSettings(generalSettings, "direct_ip_print"));
        if (res.data[0] && local == false) {
          directPrint ? handleLocalPrint(local) : handleReceiptPrint();
        };
        setActiveItemInOrder(null);
        handleClearSettle();
        setActiveItemInOrder(null);
        setLoading(false)
        //check sales limit target
        // if(authUserInfo.details.user_type === "staff" && authUserInfo?.details?.sales_limit > 0){
        //   if(res?.data[6] > authUserInfo?.details?.sales_limit){
        //     toast.success('Congratulations🎉, you have achieved your target!', {
        //       position: "top-left",
        //       autoClose: 7000,
        //       hideProgressBar: false,
        //       closeOnClick: true,
        //       pauseOnHover: true,
        //       hideProgressBar: true,
        //       // draggable: true,
        //       // progress: undefined,
        //       transition: Flip,
        //       style:{backgroundColor:"#ed8153"}
        //       });
        //   }
        // }
      } else {
        setLoading(false);
        setButtonDisabled(false);
        toast.error(
          `${_t(
            t(
              "Please enter paid amount atleast equal to the total bill amount"
            )
          )}`,
          toastObj
        );
      }
    } else {
      setLoading(false);
      setButtonDisabled(false);
      toast.error(`${_t(t("Please restart the work period"))}`, toastObj);
    }

  }


  return (
    <>
      {/* show settle  */}
      <div
        className={`fk-settle-container d-flex flex-column justify-content-center ${showSettle ? "" : "d-none"
          }`}
      >
        <CustomSpinLoader loading={buttonDisabled} />

        <div className="fk-settle">
          <div className="container-fluid">
            <div className="row gx-3">
              <div className="col-lg-6 d-none d-lg-block">
                <div className="d-flex justify-content-between px-2">
                  <div className="table-text d-block text-capitalize font-weight-bold py-3">
                    New Order {orderDetails?.table && `(Table: ${orderDetails?.table_name ? orderDetails.table_name : "-"})`}
                  </div>
                  <div className="table-text d-block text-capitalize font-weight-bold py-3">
                    {orderDetails && orderDetails?.branch?.name}
                  </div>
                </div>
                <div
                  className="fk-settle__products d-flex flex-column"
                  data-simplebar
                >
                  <div className="container-fluid">
                    <div className="row gx-3">
                      <div className="col-12">
                        {/* POS Product list will be here  */}
                        <div className="fk-price-table__body t-mt-10">
                          <div className="fk-price-table__body-top">
                            <div className="fk-table">
                              <div className="d-flex justify-content-between px-3 fk-addons-table__head">
                                <div className="mr-3">
                                  {_t(t("order token"))}: #
                                  {orderDetails?.token &&
                                    orderDetails.token?.id}
                                </div>
                                <div>
                                  {
                                    `${selectedDeliveryType && selectedDeliveryType?.name} - ${selectedParty && selectedParty?.name}`
                                  }
                                </div>
                              </div>
                              <div className="fk-table__head">
                                <div className="row g-0 border">
                                  <div className="col-1 text-center border-right">
                                    <span className="text-capitalize sm-text d-inline-block font-weight-bold t-pt-5 t-pb-5">
                                      {"S/L"}
                                    </span>
                                  </div>
                                  <div className="col-6 text-center border-right">
                                    <span className="text-capitalize sm-text d-inline-block font-weight-bold t-pt-5 t-pb-5">
                                      {"food item"}
                                    </span>
                                  </div>
                                  <div className="col-2 text-center border-right">
                                    <span className="text-capitalize sm-text d-inline-block font-weight-bold t-pt-5 t-pb-5">
                                      {"QTY"}
                                    </span>
                                  </div>
                                  <div className="col-3 text-center">
                                    <span className="text-capitalize sm-text d-inline-block font-weight-bold t-pt-5 t-pb-5">
                                      {"price"}
                                    </span>
                                  </div>
                                </div>
                              </div>
                              <div className="t-pb-30">
                                <div className="sky-is-blue reverse-this">
                                  {/* loop through order list items */}
                                  {cartItems &&
                                    Object.keys(cartItems)?.length > 0 ? (
                                    Object.values(cartItems).map(
                                      (orderListItem, orderListItemIndex) => {
                                        console.log(
                                          "21 order",
                                          orderListItem,
                                          orderListItemIndex
                                        );
                                        return (
                                          <>
                                            <div
                                              className={`fk-table-container-order ${orderListItemIndex ===
                                                activeItemInOrder && "active"
                                                } `}
                                              onClick={(e) => {
                                                e.preventDefault();
                                                //orderListItem's group wise all items
                                                // let tempItems =
                                                //   foodForPOS &&
                                                //   foodForPOS.filter(
                                                //     (tempItem) => {
                                                //       return (
                                                //         tempItem.food_group_id ===
                                                //         orderListItem.item
                                                //           .food_group_id
                                                //       );
                                                //     }
                                                //   );

                                                //orderListItem's group
                                                // let foodGroup =
                                                //   showFilterFoodGroupsByDept &&
                                                //   showFilterFoodGroupsByDept.find(
                                                //     (groupItem) => {
                                                //       return (
                                                //         groupItem.id ===
                                                //         parseInt(
                                                //           orderListItem.item
                                                //             .food_group_id
                                                //         )
                                                //       );
                                                //     }
                                                //   );

                                                // // selected pos item
                                                // let selectedItemTemp =
                                                //   tempItems &&
                                                //   tempItems.find(
                                                //     (tempSelectedItem) => {
                                                //       return (
                                                //         tempSelectedItem.id ===
                                                //         orderListItem.item.id
                                                //       );
                                                //     }
                                                //   );

                                                //set active order list index for background color of selected
                                                setActiveItemInOrder(orderListItemIndex);
                                              }}
                                            >
                                              <div
                                                className={`row g-0 border-top-0 border-bottom `}
                                              >
                                                <div className="col-1 text-center border-left d-flex justify-content-center align-items-center">
                                                  {newOrder.length -
                                                    orderListItemIndex}
                                                </div>
                                                <div
                                                  className={`col-6 border-left border-right py-2`}
                                                >
                                                  <div className="d-flex justify-content-between">
                                                    <span className={`text-capitalize d-block t-pt-5 t-pb-5 t-pl-5 t-pr-5 sm-text font-weight-bold t-mr-8 ${orderListItem?.indolj_item_id ? "text-danger" : ""}`}>
                                                      {orderListItem.item.name}
                                                    </span>
                                                    {orderListItem?.indolj_item_id ? (
                                                      "⭐ "
                                                    ) : ""}
                                                  </div>
                                                  <div className="row g-0">
                                                    {/* if item has variations show the selected in order list */}
                                                    {parseInt(
                                                      orderListItem.item
                                                        .has_variation
                                                    ) === 1 && (
                                                        <div className="col-12">
                                                          <span className="text-capitalize sm-text d-inline-block font-weight-bold t-pr-5 t-pl-5">
                                                            variation :
                                                          </span>
                                                          <span className="text-capitalize xsm-text d-inline-block badge rounded-pill bg-warning text-dark font-weight-md">
                                                            {orderListItem.variation &&
                                                              orderListItem
                                                                .variation
                                                                .variation_name
                                                              ? orderListItem
                                                                .variation
                                                                .variation_name
                                                              : "-"}
                                                          </span>
                                                        </div>
                                                      )}
                                                    {/* if item has properties show the selected in order list, loop here  */}
                                                    {orderListItem.properties &&
                                                      Object.values(orderListItem.properties)
                                                        .length > 0 &&
                                                      orderListItem.properties !==
                                                      undefined &&
                                                      orderListItem.item.property_groups
                                                        ?.map((thisIsGroup) => {

                                                          const theGroup = propertyGroupById && propertyGroupById[thisIsGroup]

                                                          let propertWithGroup = Object.keys(orderListItem.properties).includes(thisIsGroup.toString()) && Object.values(orderListItem.properties[thisIsGroup]);

                                                          return (
                                                            <div className="col-12">
                                                              {
                                                                //IsGroup && IsGroup?.length > 0 && IsGroup.includes(theGroup?.id.toString()) ?
                                                                propertWithGroup && theGroup &&
                                                                <span className="text-capitalize sm-text d-inline-block font-weight-bold t-pr-5 t-pl-5">
                                                                  {theGroup && theGroup.name + " :"}
                                                                </span>
                                                              }
                                                              {propertWithGroup && propertWithGroup?.map(
                                                                (
                                                                  propertyName
                                                                ) => {
                                                                  console.log(
                                                                    "15 here",
                                                                    propertyName
                                                                  );

                                                                  if (
                                                                    orderListItem.properties &&
                                                                    parseInt(
                                                                      bracketReplace(
                                                                        propertyName
                                                                          .item
                                                                          .property_group_id
                                                                      )
                                                                    ) ===
                                                                    theGroup?.id
                                                                  ) {
                                                                    return (
                                                                      <span className="text-capitalize xsm-text d-inline-block badge rounded-pill bg-warning text-dark font-weight-md mr-1">
                                                                        {
                                                                          propertyName
                                                                            .item
                                                                            .name
                                                                        }{" "}
                                                                        <span>
                                                                          {" "}
                                                                          {propertyName.quantity >
                                                                            1 &&
                                                                            "(" +
                                                                            propertyName.quantity +
                                                                            ")"}
                                                                        </span>
                                                                      </span>
                                                                    );
                                                                  }
                                                                  else {
                                                                    return true;
                                                                  }
                                                                }
                                                              )}
                                                            </div>
                                                          );
                                                        })}

                                                    {/* if item has properties show the selected in order list  */}
                                                  </div>
                                                </div>
                                                {/* Quantity */}
                                                <div className="col-2 text-center border-right d-flex justify-content-center align-items-center">
                                                  <div className="fk-qty t-pt-5 t-pb-5 justify-content-center table-text">
                                                    {orderListItem.quantity}
                                                  </div>
                                                </div>
                                                {/* Quantity */}

                                                {/* Price */}
                                                <div className="col-3 text-center border-right d-flex justify-content-center align-items-center">
                                                  <div className="text-capitalize sm-text font-weight-bold t-pt-5 t-pb-5">
                                                    {console.log(orderListItem)}
                                                    {parseInt(
                                                      orderListItem.item
                                                        .has_variation
                                                    ) === 1 ? (
                                                      <>
                                                        {currencySymbolLeft()}

                                                        {showPriceOfEachOrderItem(
                                                          orderListItem
                                                        )}
                                                        {currencySymbolRight()}
                                                      </>
                                                    ) : (
                                                      <>
                                                        {currencySymbolLeft()}
                                                        {showPriceOfEachOrderItem(
                                                          orderListItem
                                                        )}
                                                        {currencySymbolRight()}
                                                      </>
                                                    )}
                                                  </div>
                                                </div>
                                              </div>
                                            </div>
                                          </>
                                        );
                                      }
                                    )
                                  ) : (
                                    <div className="text-primary text-center font-weight-bold pt-5 xsm-text text-uppercase">
                                      {"Select food item to add to the list"}
                                    </div>
                                  )}
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-lg-6">
                <div className="row gx-3">
                  <div className="col-md-9">
                    {returnMoneyUsd > 0 ? (
                      <div
                        className="alert alert-danger text-center"
                        style={{ height: "56px", marginTop: "16px" }}
                      >
                        Return Amount: {roundFormatPrice(returnMoneyUsd)}
                      </div>
                    ) : (
                      <>
                        {
                          getSystemSettings(generalSettings, "loyality_enable") && getSystemSettings(generalSettings, "loyality_enable") !== "none" && (
                            <>
                              {
                                getSystemSettings(generalSettings, "loyality_enable") === "techmixers" ? (
                                  <div className="fk-settle-group t-mt-10 row">
                                    <div className="col-6">
                                      <div className="table-text font-weight-bold cursor-pointer text-center d-flex">
                                        {
                                          loyaltyPoint.availablePoints > 0 ? (
                                            <button disabled={getDisableLoyality() || loyaltyPoint.qr_code} title="send otp to customer" className={`toggle-option p-2 table-text rounded-left ${loyaltyPoint.type === "send-otp" ? "active" : "text-white bg-warning"}`} onClick={() => handleToggle("send-otp")}>SendOtp</button>
                                          ) : (
                                            <button title="get customer info" className={`toggle-option p-2 table-text rounded-left ${loyaltyPoint.type === "get-info" ? "active" : ""}`} onClick={() => handleToggle("get-info")}>Get Info</button>
                                          )
                                        }
                                        <button disabled={getDisableLoyality()} title="redeem points by code" className={`toggle-option p-2 table-text rounded-right ${loyaltyPoint.type === "code" ? "active" : ""}`} onClick={() => handleToggle("code")}>Code</button>
                                        <input
                                          disabled={loyaltyPoint.type !== "code" || (orderDetails.payment_type && orderDetails.payment_type?.length)}
                                          type="text"
                                          onKeyDown={(evt) => ["e", "E", "+", "-", "ArrowUp", "ArrowDown"].includes(evt.key) && evt.preventDefault()}
                                          onWheel={(e) => e.target.blur()}
                                          autocomplete="off"
                                          value={loyaltyPoint.qr_code}
                                          name="qr_code"
                                          style={{ minHeight: "1rem", color: "#121053" }}
                                          className="form-control ml-2 w-50 fk-settle-group__input px-2 font-weight-bold p-1 rounded-sm"
                                          placeholder="Code here..."
                                          onChange={(e) => handleGetLoyaltyChange(e)}
                                        />
                                      </div>
                                    </div>
                                    <div className="col-6 pl-0 d-flex">
                                      <input
                                        disabled={loyaltyPoint.type !== "get-info" || (orderDetails.payment_type && orderDetails.payment_type?.length)}
                                        type="number"
                                        onKeyDown={(evt) => ["e", "E", "+", "-", "ArrowUp", "ArrowDown"].includes(evt.key) && evt.preventDefault()}
                                        onWheel={(e) => e.target.blur()}
                                        value={loyaltyPoint.phn_no}
                                        name="phn_no"
                                        style={{ minHeight: "1rem", color: "#121053" }}
                                        className="form-control w-50 fk-settle-group__input px-2 mr-2 font-weight-bold p-1 rounded-sm"
                                        placeholder="Phone here..."
                                        onChange={(e) => handleGetLoyaltyChange(e)}
                                      />
                                      <input
                                        disabled
                                        type="number"
                                        onKeyDown={(evt) => ["e", "E", "+", "-", "ArrowUp", "ArrowDown"].includes(evt.key) && evt.preventDefault()}
                                        onWheel={(e) => e.target.blur()}
                                        id="settle-total"
                                        style={{ minHeight: "1rem", color: "#121053", width: "48.5%" }}
                                        className="form-control fk-settle-group__input text-right px-2 font-weight-bold p-1 rounded-sm"
                                        placeholder="Your points"
                                        value={loyaltyPoint.availablePoints}
                                      />
                                    </div>
                                  </div>
                                ) : (
                                  <div className="fk-settle-group t-mt-10 row">
                                    <div className="col-6">
                                      <div className="table-text font-weight-bold cursor-pointer text-center d-flex">
                                        <button title="redeem points by code" className={`toggle-option p-2 table-text rounded-left ${loyaltyPoint.type === "token" ? "active" : ""}`} onClick={() => handleToggle("token")}>Loyalty</button>
                                        <button disabled={getSystemSettings(generalSettings, "loyality_enable") === "indoljItemWise"} title="new registration with phone" className={`toggle-option p-2 table-text rounded-right ${loyaltyPoint.type === "phone" ? "active" : ""}`} onClick={() => handleToggle("phone")}>{getSystemSettings(generalSettings, "loyality_enable") === "indoljItemWise" ? "Get Items" : "loyalty Reg."}</button>
                                        <img title="loyalty points" style={{ marginLeft: "0.3rem", height: "2.25rem" }} src={LoyaltyImg} alt="loyalty points" />
                                      </div>
                                    </div>
                                    <div className="col-6 pl-0 d-flex">
                                      <input
                                        disabled={(orderDetails.payment_type && orderDetails.payment_type?.length) || (selectedParty && selectedParty.name?.toLowerCase() === "website")}
                                        type="text"
                                        onKeyDown={(evt) => ["e", "E", "+", "-", "ArrowUp", "ArrowDown"].includes(evt.key) && evt.preventDefault()}
                                        onWheel={(e) => e.target.blur()}
                                        autocomplete={loyaltyPoint.type === "phone" ? "on" : "off"}
                                        value={loyaltyPoint.qr_code}
                                        id="settle-total"
                                        style={{ minHeight: "1rem", color: "#121053" }}
                                        className="form-control w-50 fk-settle-group__input px-2 mr-2 font-weight-bold p-1 rounded-sm"
                                        placeholder={loyaltyPoint.type === "phone" ? "Phone here..." : "Code here..."}
                                        onChange={(e) => handleGetIndoljChange(e)}
                                      />
                                      <input
                                        disabled
                                        type="number"
                                        onKeyDown={(evt) => ["e", "E", "+", "-", "ArrowUp", "ArrowDown"].includes(evt.key) && evt.preventDefault()}
                                        onWheel={(e) => e.target.blur()}
                                        id="settle-total"
                                        style={{ minHeight: "1rem", color: "#121053", width: "48.5%" }}
                                        className="form-control fk-settle-group__input text-right px-2 font-weight-bold p-1 rounded-sm"
                                        placeholder="Your points"
                                        value={loyaltyPoint.availablePoints}
                                      />
                                    </div>
                                  </div>
                                )
                              }
                              <div className="fk-settle-group row t-mt-10">
                                <div className="col-6">
                                  <label
                                    htmlFor="settle-paid-amount"
                                    className="text-capitalize fk-settle-group__label font-weight-bold d-flex align-items-center justify-content-between"
                                  >
                                    redeem amount:
                                    <button title="clear to unlock redeem" className="text-end px-2 btn btn-sm btn-danger rounded" onClick={() => handleClearAll()}>Unlock</button>
                                  </label>
                                </div>
                                <div className="col-6 pl-0 d-flex">
                                  <input
                                    disabled
                                    type="text"
                                    onKeyDown={(evt) => ["e", "E", "+", "-", "ArrowUp", "ArrowDown"].includes(evt.key) && evt.preventDefault()}
                                    onWheel={(e) => e.target.blur()}
                                    value={loyaltyPoint.maxRedeemPoints ? loyaltyPoint.maxRedeemPoints + " Points" : ""}
                                    style={{ minHeight: "1rem", color: "#121053" }}
                                    className="form-control w-50 fk-settle-group__input px-2 mr-2 font-weight-bold p-1 rounded-sm"
                                  />
                                  <input
                                    disabled={!loyaltyPoint.verified || (orderDetails.payment_type && orderDetails.payment_type?.length) || (getSystemSettings(generalSettings, "loyality_enable") === "indolj" && selectedParty && selectedParty.name?.toLowerCase() === "website")}
                                    type="number"
                                    onKeyDown={(evt) => ["e", "E", "+", "-", "ArrowUp", "ArrowDown"].includes(evt.key) && evt.preventDefault()}
                                    onWheel={(e) => e.target.blur()}
                                    id="settle-total"
                                    style={{ minHeight: "1rem", color: "#121053", width: "48.5%" }}
                                    className="form-control fk-settle-group__input text-right px-2 font-weight-bold p-1 rounded-sm"
                                    max={loyaltyPoint.availablePoints}
                                    value={loyaltyPoint.redeemPoints || ""}
                                    onChange={(e) => handleRedeemPoint(e)}
                                  />
                                </div>
                              </div>
                            </>
                          )
                        }
                        <div className="fk-settle-group d-flex align-items-center t-mt-10">
                          <label
                            htmlFor="settle-total"
                            className="text-capitalize w-50 fk-settle-group__label font-weight-bold"
                          >
                            total:
                          </label>
                          <div
                            id="settle-total"
                            className="w-50 fk-settle-group__input text-right px-2 font-weight-bold p-1 rounded-sm"
                          >
                            {(totalsettle)}
                          </div>
                        </div>
                        <div className="fk-settle-group d-flex align-items-center t-mt-10 t-mb-15">
                          <label
                            htmlFor="settle-paid-amount"
                            className="text-capitalize w-50 fk-settle-group__label font-weight-bold"
                          >
                            paid amount:
                          </label>
                          {/* {paySelected ? (
                              <div
                                id="settle-total"
                                className="w-50 fk-settle-group__input text-right pr-2 font-weight-bold"
                              >
                                {paidMoney}
                              </div>
                            ) : (
                              )
                            } */}
                          <input
                            ref={inputRefs.paid}
                            type="number"
                            onKeyDown={(evt) => ["e", "E", "+", "-", "ArrowUp", "ArrowDown"].includes(evt.key) && evt.preventDefault()}
                            onWheel={(e) => e.target.blur()}
                            id="settle-total"
                            style={{ minHeight: "1rem", color: "#121053" }}
                            className="form-control w-50 fk-settle-group__input text-right px-2 font-weight-bold p-1 rounded-sm"
                            autoFocus
                            key={paidMoney}
                            value={paidMoney ?? ""}
                            onChange={(e) => setPaidMoney(e.target.value ? parseFloat(e.target.value) : 0)}
                          />
                        </div>
                      </>
                    )}
                    <div className={`${getSystemSettings(generalSettings, "loyality_enable") && getSystemSettings(generalSettings, "loyality_enable") !== "none" ? "fk-settle-cal-loyality" : "fk-settle-cal"} container-fluid`}>
                      <div className="row h-100 g-2 mt-1">
                        <div className="col-2">
                          <div className="row g-2 h-100">
                            <div className="col-12">
                              <button
                                className="fk-settle-cal-btn t-bg-p t-text-white"
                                onClick={() => {
                                  if (!(returnMoneyUsd > 0)) {
                                    setPaidMoney(Number(paidMoney) + 10);
                                  }
                                }}
                              >
                                10
                              </button>
                            </div>
                            <div className="col-12">
                              <button
                                className="fk-settle-cal-btn t-bg-p t-text-white"
                                onClick={() => {
                                  if (!(returnMoneyUsd > 0)) {
                                    setPaidMoney(Number(paidMoney) + 20);
                                  }
                                }}
                              >
                                20
                              </button>
                            </div>
                            <div className="col-12">
                              <button
                                className="fk-settle-cal-btn t-bg-p t-text-white"
                                onClick={() => {
                                  if (!(returnMoneyUsd > 0)) {
                                    setPaidMoney(Number(paidMoney) + 50);
                                  }
                                }}
                              >
                                50
                              </button>
                            </div>
                            <div className="col-12 mb-2">
                              <button
                                className="fk-settle-cal-btn t-bg-p t-text-white"
                                onClick={() => {
                                  if (!(returnMoneyUsd > 0)) {
                                    setPaidMoney(Number(paidMoney) + 100);
                                  }
                                }}
                              >
                                100
                              </button>
                            </div>
                          </div>
                        </div>
                        <div className="col-10">
                          <div className="row g-2 h-100">
                            <div className="col-3">
                              <div className="row g-2 h-100">
                                <div className="col-12">
                                  <button
                                    className="fk-settle-cal-btn t-bg-w"
                                    onClick={() => {
                                      if (!(returnMoneyUsd > 0)) {
                                        setPaidMoney(paidMoney > 0 ? (String(paidMoney) + 1) : 1);
                                      }
                                    }}
                                  >
                                    1
                                  </button>
                                </div>
                                <div className="col-12">
                                  <button
                                    className="fk-settle-cal-btn t-bg-w"
                                    onClick={() => {
                                      if (!(returnMoneyUsd > 0)) {
                                        setPaidMoney(paidMoney > 0 ? (String(paidMoney) + 4) : 4);
                                      }
                                    }}
                                  >
                                    4
                                  </button>
                                </div>
                                <div className="col-12">
                                  <button
                                    className="fk-settle-cal-btn t-bg-w"
                                    onClick={() => {
                                      if (!(returnMoneyUsd > 0)) {
                                        setPaidMoney(paidMoney > 0 ? (String(paidMoney) + 7) : 7);
                                      }
                                    }}
                                  >
                                    7
                                  </button>
                                </div>
                                <div className="col-12">
                                  <button
                                    className="fk-settle-cal-btn t-bg-p t-text-white"
                                    onClick={() => {
                                      if (!(returnMoneyUsd > 0)) {
                                        setPaidMoney(Number(paidMoney) + 500);
                                      }
                                    }}
                                  >
                                    500
                                  </button>
                                </div>
                              </div>
                            </div>
                            <div className="col-3">
                              <div className="row g-2 h-100">
                                <div className="col-12">
                                  <button
                                    className="fk-settle-cal-btn t-bg-w"
                                    onClick={() => {
                                      if (!(returnMoneyUsd > 0)) {
                                        setPaidMoney(paidMoney > 0 ? (String(paidMoney) + 2) : 2);
                                      }
                                    }}
                                  >
                                    2
                                  </button>
                                </div>
                                <div className="col-12">
                                  <button
                                    className="fk-settle-cal-btn t-bg-w"
                                    onClick={() => {
                                      if (!(returnMoneyUsd > 0)) {
                                        setPaidMoney(paidMoney > 0 ? (String(paidMoney) + 5) : 5);
                                      }
                                    }}
                                  >
                                    5
                                  </button>
                                </div>
                                <div className="col-12">
                                  <button
                                    className="fk-settle-cal-btn t-bg-w"
                                    onClick={() => {
                                      if (!(returnMoneyUsd > 0)) {
                                        setPaidMoney(paidMoney > 0 ? (String(paidMoney) + 8) : 8);
                                      }
                                    }}
                                  >
                                    8
                                  </button>
                                </div>
                                <div className="col-12">
                                  <button
                                    className="fk-settle-cal-btn t-bg-p t-text-white"
                                    onClick={() => {
                                      if (!(returnMoneyUsd > 0)) {
                                        setPaidMoney(Number(paidMoney) + 1000);
                                      }
                                    }}
                                  >
                                    1000
                                  </button>
                                </div>
                              </div>
                            </div>
                            <div className="col-3">
                              <div className="row g-2 h-100">
                                <div className="col-12">
                                  <button
                                    className="fk-settle-cal-btn t-bg-w"
                                    onClick={() => {
                                      if (!(returnMoneyUsd > 0)) {
                                        setPaidMoney(paidMoney > 0 ? (String(paidMoney) + 3) : 3);
                                      }
                                    }}
                                  >
                                    3
                                  </button>
                                </div>
                                <div className="col-12">
                                  <button
                                    className="fk-settle-cal-btn t-bg-w"
                                    onClick={() => {
                                      if (!(returnMoneyUsd > 0)) {
                                        setPaidMoney(paidMoney > 0 ? (String(paidMoney) + 6) : 6);
                                      }
                                    }}
                                  >
                                    6
                                  </button>
                                </div>
                                <div className="col-12">
                                  <button
                                    className="fk-settle-cal-btn t-bg-w"
                                    onClick={() => {
                                      if (!(returnMoneyUsd > 0)) {
                                        setPaidMoney(paidMoney > 0 ? (String(paidMoney) + 9) : 9);
                                      }
                                    }}
                                  >
                                    9
                                  </button>
                                </div>
                                <div className="col-12">
                                  <button
                                    className="fk-settle-cal-btn t-bg-p t-text-white"
                                    onClick={() => {
                                      if (!(returnMoneyUsd > 0)) {
                                        setPaidMoney(Number(paidMoney) + 5000);
                                      }
                                    }}
                                  >
                                    5000
                                  </button>
                                </div>
                              </div>
                            </div>
                            <div className="col-3">
                              <div className="row g-2 h-100">
                                <div className="col-12">
                                  <button
                                    className="fk-settle-cal-btn t-text-white t-bg-ac text-capitalize"
                                    onClick={() => {
                                      let theP = parseFloat(totalsettle);
                                      setPaidMoney(theP);
                                    }}
                                  >
                                    all
                                  </button>
                                </div>
                                <div className="col-12">
                                  <button
                                    className="fk-settle-cal-btn t-text-white t-bg-ac text-capitalize"
                                    onClick={() => {
                                      if (!(returnMoneyUsd > 0)) {
                                        // let theP = formatPrice(
                                        //   parseFloat(totalsettle) / 2
                                        // );
                                        // setPaidMoney(parseFloat(theP));
                                        setPaidMoney(paidMoney > 0 && (String(paidMoney) + 0));
                                      }
                                    }}
                                  >
                                    0
                                  </button>
                                </div>
                                <div className="col-12">
                                  <button
                                    className="fk-settle-cal-btn t-bg-d t-text-white"
                                    onClick={() => { handleClearAmount() }}
                                  >
                                    C
                                  </button>
                                </div>
                                <div className="col-12">
                                  <button
                                    disabled={buttonDisabled}
                                    className="fk-settle-cal-btn bg-primary t-text-white t-bg-r text-capitalize hover-effect"
                                    onClick={(e) => {
                                      if (!loading) {
                                        handleSettleOrder(e)
                                      }
                                    }}
                                  >
                                    {!loading ? "settle" : "wait"}
                                  </button>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="col-md-3">
                    <div className="d-flex flex-column justify-content-center t-mt-15">
                      <div className="fk-settle__pay" data-simplebar>
                        <div className="row gx-3">
                          <div className="col-12">
                            {/* POS Navigation will ber here */}
                            <ul className="t-list fk-pos-nav list-group">
                              <li className="fk-pos-nav__list">
                                {
                                  loyaltyPoint.customerName && (
                                    <div className="w-100 mb-3 font-weight-md text-truncate">
                                      {loyaltyPoint.customerName}
                                    </div>
                                  )
                                }
                                <div className="w-100 mb-3 d-flex align-items-center">
                                  <label className="mr-2">Tip:</label>
                                  <input
                                    type="number"
                                    onKeyDown={(evt) => ["e", "E", "+", "-", "ArrowUp", "ArrowDown"].includes(evt.key) && evt.preventDefault()}
                                    onWheel={(e) => e.target.blur()}
                                    className="form-control fk-settle-group__input py-1 px-2 font-weight-bold"
                                    autoFocus
                                    value={orderDetails.order_tip}
                                    onChange={(e) => setOrderDetails({ ...orderDetails, order_tip: e.target.value })}
                                  />
                                </div>
                                <button
                                  type="button"
                                  onClick={() => handleGoBack()}
                                  className="w-100 t-text-dark t-heading-font btn alert alert-danger font-weight-bold text-uppercase py-3 mb-3"
                                >
                                  Go back
                                </button>
                              </li>
                              {/* paymentTypes */}
                              {paymentTypeAvailable &&
                                paymentTypeAvailable.map(
                                  (groupItem, groupIndex) => {
                                    return (
                                      <li
                                        className="fk-pos-nav__list"
                                        key={groupIndex}
                                      >
                                        <button
                                          type="button"
                                          //set active or !
                                          className={`w-100 t-text-dark t-heading-font btn btn-outline-danger font-weight-bold text-uppercase py-3 hover-effect ${orderDetails &&
                                              orderDetails.payment_type !== null &&
                                              orderDetails.payment_type[0]?.id === groupItem.id
                                              ? "active"
                                              : ""
                                            }`}
                                          onClick={() => {
                                            handleSetpaymentTypeSingle(
                                              groupItem
                                            );
                                          }}
                                        >
                                          {groupItem.name}
                                        </button>
                                      </li>
                                    );
                                  }
                                )}
                              {/*split paymentTypes */}
                              {paymentTypeAvailable &&
                                paymentTypeAvailable?.length > 1 && (
                                  <li className="mt-2" title="Clear Paid Amount for Split Payment">
                                    <button
                                      type="button"
                                      onClick={() => {
                                        setPayModal(true);
                                        handleClearAll()
                                      }}
                                      className="w-100 t-text-dark t-heading-font btn alert alert-danger font-weight-bold text-uppercase py-3 mb-3"
                                    >
                                      Split Payment
                                    </button>
                                  </li>
                                )}

                            </ul>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/*split pay modal */}
      <SplitPayment
        handleClick={handleClick}
        totalsettle={totalsettle}
        payModal={payModal}
        handleSetPayment={handleSetPayment}
        paySelected={paySelected}
        paymentTypeAvailable={paymentTypeAvailable}
        payment={payment}
        handleSetpaymentTypeMuliple={handleSetpaymentTypeMuliple}
        handleSplitPayment={handleSplitPayment}
      />

      {/* Card Modal */}
      <CardModal
        cardAdd={cardAdd}
        handleCardSubmit={handleCardSubmit}
        inputRefs={inputRefs}
        cardNumber={cardNumber}
        handleCardChange={handleCardChange}
        bank_required={Number((paySelected || orderDetails.payment_type?.[0])?.bank_required) === 1}
      />

    </>
  );
};

export default memo(SettleOrder);
